import { Form, Input, Select } from "antd";
import { formatPositionLabel } from "../../../utils/generalUtils";

const { Option } = Select;

const PositionDropdownField = ({ field, form }) => (
  <>
    <Form.Item
      hidden={field?.hidden}
      name={field.name}
      label={field.label}
      extra={field.extra}
      rules={field.rules}
    >
      <Select
        disabled={field.disabled}
        placeholder={field.placeholder}
        onChange={(value) => {
          const selectedPosition = field.dropdownItems?.find(
            (item) => item.position_id === value
          );
          form.setFieldsValue({
            [field.name]: value,
            [field.inputName]:
              selectedPosition?.complete_position_name ||
              selectedPosition?.position_name ||
              "",
          });
        }}
      >
        {field.dropdownItems?.map((item) => (
          <Option
            key={item.position_id}
            value={item.position_id}
            disabled={Boolean(item?.is_inactive)}
          >
            {formatPositionLabel(item)}
          </Option>
        ))}
      </Select>
    </Form.Item>
    <Form.Item name={field.inputName} hidden>
      <Input disabled />
    </Form.Item>
  </>
);

export default PositionDropdownField;
